// @ts-strict-ignore
import React from 'react';


type UseModalGroupProps<T extends string> = {
  initialState?: {
    openedModal: T;
  };
};

/**
 * Type-safe hook to control the open/close state of multiple modals with simple
 * ergonomics, while guaranteeing that opening a modal closes all others
 */
export function useModalGroup<T extends string>(modalsConfig?: UseModalGroupProps<T>) {
  const [openedModal, setOpenedModal] = React.useState<T>(
    modalsConfig?.initialState?.openedModal ?? null,
  );

  return {
    open: (modalName: T) => setOpenedModal(modalName),
    close: () => setOpenedModal(null),
    openedModal,
  };
}
